export default __webpack_public_path__ + "img/rank1-b692eea8.png";